var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-custom-query-logic-tree" },
    [
      _vm.rootNode
        ? _c("DsfCustomQueryLogicNode", { attrs: { data: _vm.rootNode } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }